export const INTERNAL_SERVER_ERROR = 500
export const OK = 200
export const MOVED_PERMANENTLY = 301
export const MOVED_TEMPORARILY = 302
export const NOT_FOUND = 404
